import isType from './is-type';
export default (function (value) {
    return Array.isArray ?
        Array.isArray(value) :
        isType(value, 'Array');
});
//# sourceMappingURL=is-array.js.map